// src/config/courseFieldRules.js

export const COURSE_FIELD_RULES = {
    name: {
      required: true,
      minLength: 20,
      maxLength: 70,
    },
  
    description: {
      required: true,
      minLength: 100,
      maxLength: 350,
    },
  
    learningGoals: {
      required: true,
      minLength: 150,
      maxLength: 1000,
    },
  
    assessmentDescription: {
      required: true,
      minLength: 5,
      maxLength: 20,
    },
  
    lessonsCount: {
      required: true,
      min: 0,
      max: 30,
    },
  
    lessonTitle: {
      required: true,
      minLength: 10,
      maxLength: 80,
    },
  
    lessonCoverage: {
      required: true,
      minLength: 115,
      maxLength: 400,
    },
  
    totalPrice: {
      required: true,
      min: 10,
      max: 500,
    },
  
    minStudents: {
      required: true,
      min: 1,
      max: 8,
    },
  
    maxStudents: {
      required: true,
      min: 1,
      max: 8,
    },
  
    courseDuration: {
      required: true,
      min: 1,
    },
  
    singleClassDurationNumber: {
      required: true,
      min: 1,
    },
  
    ageMin: {
      required: true,
      min: 5,
    },
  
    ageMax: {
      required: true,
      min: 5,
      max: 18,
    },
  };